module.exports = __webpack_public_path__ + "static/media/example-04.3588fd3d.jpg";